import React from "react";
import { motion } from "framer-motion";
import { COLOR_PRIMARY } from "../../config/Constants";

export const Container = ({ children }) => (
  <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">{children}</div>
);

export const Section = ({ id, eyebrow, title, subtitle, children }) => (
  <section id={id} className="scroll-mt-24 py-16 sm:py-24">
    <Container>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {eyebrow && (
          <div
            className="text-sm font-semibold tracking-widest uppercase"
            style={{ color: COLOR_PRIMARY }}
          >
            {eyebrow}
          </div>
        )}
        {title && (
          <h2 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tight text-gray-900">
            {title}
          </h2>
        )}
        {subtitle && (
          <p className="mt-3 text-lg text-gray-600 max-w-3xl">{subtitle}</p>
        )}
      </motion.div>
      <div className="mt-10">{children}</div>
    </Container>
  </section>
);
